import { render, staticRenderFns } from "./Ligas.vue?vue&type=template&id=aef87b30&scoped=true"
import script from "./Ligas.vue?vue&type=script&lang=ts&setup=true"
export * from "./Ligas.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Ligas.vue?vue&type=style&index=0&id=aef87b30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef87b30",
  null
  
)

export default component.exports